export default __webpack_public_path__ + "static/media/jewish-2.38b0331c.jpg";